<template>
  <b-container>
    <b-row style="text-align: center;">
      <b-col class="photography-intro-banner">
        <ChoiboiLogo
          :isLink="false"
          fontSize="50px" />
        <p class="logo-subtitle">PHOTOGRAPHY</P>
        <p>
          Amateur photographer &#124; Hobby &#124; Equipment&#58; Sony A7ii &amp; Tamron 28 - 75mm f/2.8
        </p>
      </b-col>
    </b-row>

    <ImageGrid :images="photographyImageData.images"/>
  </b-container>
</template>

<script>
import ChoiboiLogo from '../components/ChoiboiLogo';
import ImageGrid from '../components/layout/ImageGrid';

import photographyImageData from '../assets/data/photography-data.json';

export default {
  name: 'PhotographyPage',
  components: {
    ChoiboiLogo,
    ImageGrid
  },
  data() {
    return {
      photographyImageData
    }
  }
}
</script>

<style lang="scss" scoped>
.photography-intro-banner {
  margin-top: 2rem;
}

p {
  &.logo-subtitle {
    text-transform: uppercase;
    font-size: 44px;
    margin-top: -20px;
  }
}
</style>
